import { Injectable } from '@angular/core';

import { FileType } from '../shared/models/file-item.model';
import { OperationStream } from '../shared/models/operation-stream.model';
import { MruData } from '../shared/mru/mru-data.service';
import { RecommendedDataServiceFactory } from './recommended-data-service.factory';

@Injectable({
    providedIn: 'root',
    useFactory: (recommendedDataServiceFactory: RecommendedDataServiceFactory) => recommendedDataServiceFactory.getRecommendedService(),
    deps: [
        RecommendedDataServiceFactory
    ]
})
export abstract class RecommendedDataService {
    public abstract getRecommendedDocs(types?: Set<FileType>): OperationStream<MruData>;
    public abstract updateRecommendedDocs(types?: Set<FileType>): Promise<void>;
    public abstract removeDocument(docId: string, snoozeUntil?: Date): Promise<void>;
}
